import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";

interface StackableBoxProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  isFirst?: boolean;
  isLast?: boolean;
  isActive?: boolean;
}

const StackableBox: React.FC<StackableBoxProps> = ({
  label,
  icon,
  onClick,
  isFirst = false,
  isLast = false,
  isActive = false,
}) => {
  const theme = useTheme();

  const getBorderRadius = (): SxProps => {
    if (isFirst) {
      return {
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
      };
    }
    if (isLast) {
      return {
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      };
    }
    return {};
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.background.paper,
        p: 2,
        width: "110px",
        cursor: "pointer",
        "&:hover": {
          "& .stackable-box-icon": {
            color: theme.palette.primary.main,
          },
          "& .stackable-box-text": {
            color: theme.palette.primary.main,
          },
        },
        ...getBorderRadius(),
      }}
      onClick={onClick}
    >
      <Box
        className="stackable-box-icon"
        sx={{
          color: isActive ? theme.palette.primary.main : "inherit",
          transition: "color 0.2s ease-in-out",
          display: "flex",
          "& svg": {
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
          },
        }}
      >
        {icon}
      </Box>
      <Typography
        className="stackable-box-text"
        variant="h6"
        sx={{
          fontSize: { xs: "0.75rem", sm: "1.00rem" },
          marginTop: 1,
          color: isActive ? theme.palette.primary.main : "inherit",
          transition: "color 0.2s ease-in-out",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default StackableBox;
